export default {
  marketingConsent: false,
  cookiebotLoaded: false,
  cookiebotNotFound: false,

  init() {
    window.addEventListener('CookiebotOnLoad', () => {
      this.cookiebotLoaded = true;
      this.checkConsent();

      window.addEventListener('CookiebotOnAccept', () => {
        this.checkConsent();
      });

      window.addEventListener('CookiebotOnDecline', () => {
        this.checkConsent();
      });
    });

    setTimeout(() => {
      if (!this.cookiebotLoaded && !window.Cookiebot) {
        console.warn(
          'CookiebotOnLoad not fired and Cookiebot not found after 1500ms. Assuming that Cookiebot is not active.'
        );
        this.cookiebotNotFound = true;
      } else {
        this.checkConsent();
      }
    }, 1500);
  },

  checkConsent() {
    if (!window.Cookiebot) return;
    this.cookiebotLoaded = true;
    this.cookiebotNotFound = false;
    this.marketingConsent = window.Cookiebot.consent && window.Cookiebot.consent.marketing;
  },

  renew() {
    window.Cookiebot && window.Cookiebot.renew();
  },
};
